module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("I see you stand like greyhounds in the slips, Straining upon the start. The game’s afoot.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("SHAKESPEARE")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', {
    staticClass: "em"
  }, [_vm._v("Henry V")]), _vm._v(", III, i")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Come, Watson, come!” he cried. “The game is afoot.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("SIR ARTHUR CONAN DOYLE")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', {
    staticClass: "em"
  }, [_vm._v("The Return of Sherlock Holmes:")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("“Adventure of the Abbey Grange”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Hear all peoples, and rejoice all lands, for the slayer of Death comes, the Liberator, the son of Kameron Kisster. In the seven hundredth Festival, he shall come forth in the land of Suss. Naked and crying he shall come into the world and Eleal shall wash him. She shall clothe him and nurse him and comfort him. Be merry and give thanks; welcome this mercy and proclaim thine deliverance, for he will bring death to Death.")]), _vm._v(" "), _c('p', {
    staticClass: "right _idGenParaOverride-1"
  }, [_c('em', {
    staticClass: "em"
  }, [_vm._v("The Filoby Testament")]), _vm._v(", 368")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-923c9e9a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PastImperative3.vue
// module id = 78
// module chunks = 0